import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { FormattedMessage, injectIntl, intlShape, useIntl } from '../../util/reactIntl';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';

import { H3, Page, PaginationLinks, UserNav, LayoutSingleColumn, NamedLink, Modal, IconSpinner, NamedRedirect, SkeletonLoader } from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useConfiguration } from '../../context/configurationContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import css from './TransactionHistoryPage.module.css';
import { propTypes } from '../../util/types';
import moment from 'moment';


export class TransactionHistoryPageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = { listingMenuOpen: null, };
    // this.onToggleMenu = this.onToggleMenu.bind(this);
  }



  render() {
    const {
      scrollingDisabled,
      intl,
      currentUser,
      PurchaseCredits,
      vendorSpentCredits,
      fetchPurchaseCreditsInProgress
    } = this.props;
    
    const totalVendorCredits = PurchaseCredits && PurchaseCredits.creditTypeTotal;
  
    const purchaseCreditTime = PurchaseCredits?.vendorCredits && PurchaseCredits.vendorCredits.length && PurchaseCredits.vendorCredits[PurchaseCredits.vendorCredits.length-1]?.createdAt;
    
    const creditTime = purchaseCreditTime ? moment(purchaseCreditTime)?.format('DD-MM-YYYY hh:mm A') :null ;
    
    const title = intl.formatMessage({ id: 'ManageListingsPage.title' });

    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn
          topbar={
            <>
              <TopbarContainer currentPage="TransactionHistoryPage" />
              <UserNav currentPage="TransactionHistoryPage" currentUser={currentUser} />
            </>
          }
          footer={<FooterContainer />}
        >
          {fetchPurchaseCreditsInProgress ? <IconSpinner type={true} /> : 
          <div className={css.pageWrapper}>
            <div className={css.mainWrapper}>
              <h3 className={css.mainTitle}>
                <FormattedMessage id="TransactionHistoryPage.title" />
              </h3>
              <div className={css.transactionBox}>

                <div className={css.totalPoints}>
                  
                  <h4 >
                    <span >Total Purchase credit points - </span>
                  </h4>
                  <p>{totalVendorCredits + " " + "Points"}</p>
                </div>
                <div className={css.purchaseTime}>
                 <h4> <span>Purchase Date and Time </span></h4>
                 <p> {creditTime}</p>
                </div>
                <div className={css.creditPoints}>
                  <h4>
                  Available credit points 
                  </h4>
                  <p>{PurchaseCredits?.totalCredits + " " + "Points"}</p>
                   </div>
              </div>
              <div className={css.debitHistoryTable}>
                <table>
                  <thead>
                    <H3 className={css.mainTitle}>
                      Debit History
                    </H3>
                  </thead>
                  <tbody>
                    {vendorSpentCredits && vendorSpentCredits.vendorCredits && vendorSpentCredits.vendorCredits.map((st, index) => {
                      const transactionType = st.type
                      const DebitMoney = st.credits;
                      const debitTime = moment(st.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                      const transactionId = st.transactionId;
                      return (
                        <tr>
                          <td>{transactionId}</td>
                          <td>{DebitMoney +" " + "Points"}</td>
                          <td>{debitTime}</td>
                          <td>{transactionType}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
        </LayoutSingleColumn>
      </Page>
    );
  }
}

TransactionHistoryPageComponent.defaultProps = {
  listings: [],
  pagination: null,
  queryListingsError: null,
  queryParams: null,
  closingListing: null,
  closingListingError: null,
  openingListing: null,
  openingListingError: null,
};

const { arrayOf, bool, func, object, shape, string } = PropTypes;

TransactionHistoryPageComponent.propTypes = {
  closingListing: shape({ uuid: string.isRequired }),
  closingListingError: shape({
    listingId: propTypes.uuid.isRequired,
    error: propTypes.error.isRequired,
  }),
  // listings: arrayOf(propTypes.ownListing),
  onCloseListing: func.isRequired,
  onOpenListing: func.isRequired,
  openingListing: shape({ uuid: string.isRequired }),
  openingListingError: shape({
    listingId: propTypes.uuid.isRequired,
    error: propTypes.error.isRequired,
  }),
  pagination: propTypes.pagination,
  queryInProgress: bool.isRequired,
  queryListingsError: propTypes.error,
  queryParams: object,
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    PurchaseCredits,
    pagination,
    fetchPurchaseCreditsInProgress,
    fetchPurchaseCreditsError,
    vendorSpentCredits,
  } = state.TransactionHistoryPage;

  return {
    PurchaseCredits,
    pagination,
    fetchPurchaseCreditsInProgress,
    fetchPurchaseCreditsError,
    vendorSpentCredits,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) => dispatch(manageDisableScrolling(componentId, disableScrolling)),
});


const TransactionHistoryPage = props => {
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const history = useHistory();
  const intl = useIntl();

  return (
    <TransactionHistoryPageComponent
      routeConfiguration={routeConfiguration}
      marketplaceName={config.marketplaceName}
      history={history}
      intl={intl}
      {...props}
    />
  );
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(TransactionHistoryPage);
